"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndValidateDbTraceScoreList = exports.filterAndValidateDbLegacyTraceScoreList = exports.filterAndValidateDbScoreList = exports.validateDbScore = void 0;
const schemas_1 = require("../api/v1/schemas");
const scores_1 = require("../../../../domain/scores");
/**
 * Use this function when pulling a single score from the database before using in the application to ensure type safety.
 * The score is expected to pass the validation. If a score fails validation, an error will be thrown.
 * @param score
 * @returns validated score
 * @throws error if score fails validation
 */
const validateDbScore = (score) => scores_1.ScoreSchema.parse(score);
exports.validateDbScore = validateDbScore;
/**
 * Use this function when pulling a list of scores from the database before using in the application to ensure type safety.
 * All scores are expected to pass the validation. If a score fails validation, it will be logged to Otel.
 * This function filters scores by the specified data types and validates them.
 * @param scores - List of scores to filter and validate
 * @param dataTypes - Array of data types to filter by (required)
 * @param includeHasMetadata - Whether to include hasMetadata field
 * @param onParseError - Optional callback for parse errors
 * @returns list of validated and filtered scores
 */
const filterAndValidateDbScoreList = ({ scores, dataTypes, includeHasMetadata = false, onParseError, }) => {
    return scores.reduce((acc, ts) => {
        // Filter by dataType first
        if (!dataTypes.includes(ts.dataType)) {
            return acc;
        }
        const result = scores_1.ScoreSchema.safeParse(ts);
        if (result.success) {
            const score = { ...result.data };
            if (includeHasMetadata) {
                Object.assign(score, { hasMetadata: ts.hasMetadata ?? false });
            }
            acc.push(score);
        }
        else {
            console.error("Score parsing error: ", result.error);
            onParseError?.(result.error);
        }
        return acc;
    }, []);
};
exports.filterAndValidateDbScoreList = filterAndValidateDbScoreList;
const filterAndValidateDbLegacyTraceScoreList = ({ scores, includeHasMetadata = false, onParseError, }) => {
    return scores.reduce((acc, ts) => {
        const result = schemas_1.APIScoreSchemaV1.safeParse(ts);
        if (result.success) {
            const score = { ...result.data };
            if (includeHasMetadata) {
                Object.assign(score, { hasMetadata: ts.hasMetadata ?? false });
            }
            acc.push(score);
        }
        else {
            console.error("Score parsing error: ", result.error);
            onParseError?.(result.error);
        }
        return acc;
    }, []);
};
exports.filterAndValidateDbLegacyTraceScoreList = filterAndValidateDbLegacyTraceScoreList;
/**
 * @deprecated
 * @alias
 * Use `filterAndValidateDbScoreList` instead. This function is only used for the legacy v1 API where scores were only associated with traces.
 * Use this function when pulling a list of scores from the database before using in the application to ensure type safety.
 * All scores are expected to pass the validation. If a score fails validation, it will be logged to Otel.
 * @param scores
 * @returns list of validated scores
 */
exports.filterAndValidateDbTraceScoreList = exports.filterAndValidateDbLegacyTraceScoreList;
